/* Best Vision Optics -- collection filter behaviour.
   The filters work with JavaScript switched off: the sidebar is a plain GET
   form and every tile is a real link. This file only removes the friction --
   auto-applying on desktop, and turning the sidebar into a drawer on phones. */
(function () {
  var form = document.querySelector('[data-facets-form]');
  if (!form) return;

  var drawer  = document.querySelector('[data-facets]');
  var scrim   = document.querySelector('[data-facets-scrim]');
  var openBtn = document.querySelector('[data-facets-open]');
  var closeBtn= document.querySelector('[data-facets-close]');
  var wide    = window.matchMedia('(min-width: 990px)');

  function setOpen(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    if (scrim) scrim.classList.toggle('is-open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on && closeBtn) closeBtn.focus();
  }

  if (openBtn)  openBtn.addEventListener('click', function () { setOpen(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
  if (scrim)    scrim.addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') setOpen(false);
  });

  /* Empty price boxes would otherwise ride along as blank query parameters,
     leaving junk like price.gte= in the address bar. Switch them off for the
     length of the submit so they are left out, then switch them back on. */
  function submit() {
    var blanks = [];
    var nums = form.querySelectorAll('input[type=number]');
    for (var i = 0; i < nums.length; i++) {
      if (nums[i].value === '') { nums[i].disabled = true; blanks.push(nums[i]); }
    }
    if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    setTimeout(function () {
      for (var j = 0; j < blanks.length; j++) { blanks[j].disabled = false; }
    }, 0);
  }

  /* On a wide screen, ticking a box reloads the grid immediately. Inside a
     phone drawer that would be maddening, so there we wait for Apply. */
  form.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'number') return;
    if (wide.matches) submit();
  });

  var applyBtn = form.querySelector('[data-facets-apply]');
  if (applyBtn) applyBtn.addEventListener('click', function (e) { e.preventDefault(); submit(); });

  /* Price boxes: wait until typing stops. */
  var timer;
  form.addEventListener('input', function (e) {
    if (!e.target || e.target.type !== 'number') return;
    if (!wide.matches) return;
    clearTimeout(timer);
    timer = setTimeout(submit, 800);
  });
})();
